import { render, staticRenderFns } from "./FeedbackItem.vue?vue&type=template&id=65a76faa&scoped=true&"
import script from "./FeedbackItem.vue?vue&type=script&lang=js&"
export * from "./FeedbackItem.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackItem.vue?vue&type=style&index=0&id=65a76faa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a76faa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VListItem,VListItemContent,VRow})
